import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../../../features/auth";
import { PATHS } from "../../../routes/paths";
import { UserRole, hasOnlyRole } from "@myapp/contract";

export function RequireRole({
  roles,
  children,
}: {
  roles: Array<Exclude<UserRole, null>>;
  children: JSX.Element;
}) {
  const { user } = useAuthStore();
  const userRoles = user?.roles ?? [];

  if (userRoles.length === 0) return <Navigate to={PATHS.login} replace />;
  if (!roles.some((r) => userRoles.includes(r))) {
    const fallback = hasOnlyRole(userRoles, "WORKER") ? PATHS.workerCalendar : PATHS.workOrderPage;
    return <Navigate to={fallback} replace />;
  }

  return children;
}
